import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { makePrioStyles } from '../../../theme/utils';

const useStyles = makePrioStyles((theme) => ({
  menu: {
    background: 'none',
    border: 'none',
  },
  icon: {
    marginRight: theme.old.spacing.unit(1.5),
    width: 18,
  },
}));

interface ProjectContactsMenuProps {
  selectedList?: string;
}

export const ProjectContactsMenu: React.FC<ProjectContactsMenuProps> = (
  props
) => {
  const { selectedList } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Menu className={classes.menu} selectedKeys={[selectedList]} mode="inline">
      <Menu.Item key="project-contacts-internal">
        <Link to="../project-contacts-internal">
          <FontAwesomeIcon
            fixedWidth
            icon={['fal', 'user-cog']}
            className={classes.icon}
          />
          {t('projects:projectSettingsNav.internalProjectContacts')}
        </Link>
      </Menu.Item>
      <Menu.Item key="project-contacts-external">
        <Link to="../project-contacts-external">
          <FontAwesomeIcon
            fixedWidth
            icon={['fal', 'user-cog']}
            className={classes.icon}
          />
          {t('projects:projectSettingsNav.externalProjectContacts')}
        </Link>
      </Menu.Item>
      <Menu.Item key="project-distribution-list">
        <Link to="../project-distribution-list">
          <FontAwesomeIcon
            fixedWidth
            icon={['fal', 'clipboard-list']}
            className={classes.icon}
          />
          {t('projects:projectSettingsNav.distributionLists')}
        </Link>
      </Menu.Item>
    </Menu>
  );
};

export default ProjectContactsMenu;
